<template>
  <v-container fluid class="company-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/company/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="companies-table"
              show-select
              single-select
              item-key="_id"
              sort-by="companyname"
              :footer-props="footer"
              :headers="headers"
              :items="companies"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Company?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteCompany.companyname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteCompany)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.companyimage="{ item }">
                <v-img
                  v-if="item.companyimage" 
                  v-bind:src="item.companyimage"
                  max-height="60"
                  max-width="60"
                ></v-img>
              </template>
              <template v-slot:item.companyname="{ item }">
                <a class="primaryConst--text">{{ item.companyname }}</a>
              </template>
              <template v-slot:item.companyemail="{ item }">
                <a class="primaryConst--text">{{ item.companyemail }}</a>
              </template>
              <template v-slot:item.companyid="{ item }">
                {{ item.companyid }}
              </template>
              <template v-slot:item.companystatus="{ item }">
                <v-chip
                  v-if="item.companystatus"
                  :color="item.companystatus=='Active' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.companystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'companyList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteCompany: {},
      headers: [
        { text: 'Image', value: 'companyimage', sortable: false },
        { text: 'Type', value: 'companytype' },
        { text: 'Name', value: 'companyname' },
        { text: 'Code', value: 'companycode' },
        { text: 'Status', value: 'companystatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      companyid: ['admin', 'company'],
      editedIndex: -1,
      editedItem: {
        companyname: '',
        image: '',
        companyid: '',
        company: '',
        companytype: '',
        companystatus: '',
        create: '',
      },
      defaultItem: {
        companyname: '',
        image: '',
        companyid: '',
        company: '',
        companytype: '',
        companystatus: '',
        create: '',
      },
      text: '',
    }
  },

  computed: {
    ...mapState('Company', ['companies', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit company'
    },
  },

  watch: {

  },

  methods: {
    ...mapActions('Company', [ "getCompaniesRequest", "deleteCompanyRequest", "updateCompanyRequest", "createCompanyRequest" ]),
    editItem(item) {
      this.$router.push({ name: 'CompanyEdit', params: item })
    },
    deleteItem(item) {

      //const pos = this.companies.map(function(company) { return company._id; }).indexOf(item._id);
      //this.companies.splice(pos, 1);
      this.deleteCompanyRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteCompany = {
        _id: item._id,
        companyname: item.companyname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },
  },
  created () {
    this.getCompaniesRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
